import { AttackType } from "../../types/enum/Game"
import type { Board } from "../board"
import type { PokemonEntity } from "../pokemon-entity"
import { AbilityStrategy } from "./ability-strategy"

export function isInPrecipiceBladesArea(
  casterX: number,
  casterY: number,
  targetX: number,
  targetY: number,
  cellX: number,
  cellY: number
) {
  const targetsDiagonally = casterX !== targetX && casterY !== targetY
  return targetsDiagonally
    ? Math.abs(cellX - casterX) === Math.abs(cellY - casterY)
    : cellX === casterX || cellY === casterY
}

export class PrecipiceBladesStrategy extends AbilityStrategy {
  process(
    pokemon: PokemonEntity,
    board: Board,
    target: PokemonEntity,
    crit: boolean
  ) {
    super.process(pokemon, board, target, crit)
    const damage = [25, 50, 100, 120, 200][pokemon.stars - 1] ?? 200
    board.forEach((x: number, y: number, tg: PokemonEntity | undefined) => {
      if (
        tg &&
        pokemon.team !== tg.team &&
        isInPrecipiceBladesArea(
          pokemon.positionX,
          pokemon.positionY,
          target.positionX,
          target.positionY,
          x,
          y
        )
      ) {
        tg.handleSpecialDamage(damage, board, AttackType.SPECIAL, pokemon, crit)
        pokemon.broadcastAbility({ positionX: x, positionY: y })
      }
    })
  }
}
